export const webConfig = {
  sectionOffset: -220,
  menuOffset: 150,
  categoryIdPrefix: "section-",
  categoryNamePrefix: "name-",
  navItemIdPrefix: "navItem-",
};
